export default __webpack_public_path__ + "static/2024-img-articolo-dicembre1-33b9e14ecb3c558c611e68f87430d9e3.jpg";